export function getStyles(
  theme: "filled" | "outline",
  size: "standard" | "large",
  width: "auto" | "full"
): string {
  const height = size === "large" ? "48px" : "44px";
  const fontSize = size === "large" ? "17px" : "16px";
  const iconSize = size === "large" ? "22px" : "20px";
  const paddingX = size === "large" ? "20px" : "16px";
  const gap = size === "large" ? "10px" : "10px";
  const radius = "8px";
  const brandBlue = "#0E6FFF";

  const isFilled = theme === "filled";
  const bg = isFilled ? brandBlue : "#fff";
  const color = isFilled ? "#fff" : "#1f1f1f";
  const border = isFilled ? "none" : `1px solid #dadce0`;
  const hoverBg = isFilled ? "#0b5fdb" : "#f7f8f8";
  const activeBg = isFilled ? "#094cc0" : "#eef0f1";

  return `
:host {
  display: inline-block;
  ${width === "full" ? "width: 100%;" : ""}
}

.trustid-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${gap};
  height: ${height};
  padding: 0 ${paddingX};
  border: ${border};
  border-radius: ${radius};
  background: ${bg};
  color: ${color};
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: ${fontSize};
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: background 0.15s ease, box-shadow 0.15s ease;
  ${width === "full" ? "width: 100%;" : ""}
}

.trustid-btn:hover {
  background: ${hoverBg};
  ${!isFilled ? "box-shadow: 0 1px 3px rgba(0,0,0,0.08);" : ""}
}

.trustid-btn:active {
  background: ${activeBg};
}

.trustid-btn:focus-visible {
  outline: 2px solid ${brandBlue};
  outline-offset: 2px;
}

.trustid-btn svg {
  width: ${iconSize};
  height: ${iconSize};
  flex-shrink: 0;
}
`.trim();
}
